// package: admin
// file: brank.as/gunk/core-products/pay/v1/admin/all.proto

var brank_as_gunk_core_products_pay_v1_admin_all_pb = require("./all_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var BillingAdminService = (function () {
  function BillingAdminService() {}
  BillingAdminService.serviceName = "admin.BillingAdminService";
  return BillingAdminService;
}());

BillingAdminService.CreateBilling = {
  methodName: "CreateBilling",
  service: BillingAdminService,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_core_products_pay_v1_admin_all_pb.CreateBillingRequest,
  responseType: brank_as_gunk_core_products_pay_v1_admin_all_pb.CreateBillingResponse
};

BillingAdminService.BillingHistory = {
  methodName: "BillingHistory",
  service: BillingAdminService,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_core_products_pay_v1_admin_all_pb.BillingHistoryRequest,
  responseType: brank_as_gunk_core_products_pay_v1_admin_all_pb.BillingHistoryResponse
};

BillingAdminService.UpdateBilling = {
  methodName: "UpdateBilling",
  service: BillingAdminService,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_core_products_pay_v1_admin_all_pb.UpdateBillingRequest,
  responseType: brank_as_gunk_core_products_pay_v1_admin_all_pb.UpdateBillingResponse
};

BillingAdminService.UpdateSubscription = {
  methodName: "UpdateSubscription",
  service: BillingAdminService,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_core_products_pay_v1_admin_all_pb.UpdateSubscriptionRequest,
  responseType: brank_as_gunk_core_products_pay_v1_admin_all_pb.UpdateSubscriptionResponse
};

exports.BillingAdminService = BillingAdminService;

function BillingAdminServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

BillingAdminServiceClient.prototype.createBilling = function createBilling(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingAdminService.CreateBilling, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingAdminServiceClient.prototype.billingHistory = function billingHistory(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingAdminService.BillingHistory, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingAdminServiceClient.prototype.updateBilling = function updateBilling(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingAdminService.UpdateBilling, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingAdminServiceClient.prototype.updateSubscription = function updateSubscription(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingAdminService.UpdateSubscription, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.BillingAdminServiceClient = BillingAdminServiceClient;

var InvoiceAdminService = (function () {
  function InvoiceAdminService() {}
  InvoiceAdminService.serviceName = "admin.InvoiceAdminService";
  return InvoiceAdminService;
}());

InvoiceAdminService.UpdateInvoice = {
  methodName: "UpdateInvoice",
  service: InvoiceAdminService,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_core_products_pay_v1_admin_all_pb.UpdateInvoiceRequest,
  responseType: brank_as_gunk_core_products_pay_v1_admin_all_pb.UpdateInvoiceResponse
};

exports.InvoiceAdminService = InvoiceAdminService;

function InvoiceAdminServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InvoiceAdminServiceClient.prototype.updateInvoice = function updateInvoice(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(InvoiceAdminService.UpdateInvoice, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InvoiceAdminServiceClient = InvoiceAdminServiceClient;

var JobAdminService = (function () {
  function JobAdminService() {}
  JobAdminService.serviceName = "admin.JobAdminService";
  return JobAdminService;
}());

JobAdminService.RunOutdatedSub = {
  methodName: "RunOutdatedSub",
  service: JobAdminService,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_core_products_pay_v1_admin_all_pb.RunOutdatedSubRequest,
  responseType: brank_as_gunk_core_products_pay_v1_admin_all_pb.RunOutdatedSubResponse
};

JobAdminService.NotifyPayable = {
  methodName: "NotifyPayable",
  service: JobAdminService,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_core_products_pay_v1_admin_all_pb.NotifyPayableRequest,
  responseType: brank_as_gunk_core_products_pay_v1_admin_all_pb.NotifyPayableResponse
};

exports.JobAdminService = JobAdminService;

function JobAdminServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

JobAdminServiceClient.prototype.runOutdatedSub = function runOutdatedSub(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(JobAdminService.RunOutdatedSub, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

JobAdminServiceClient.prototype.notifyPayable = function notifyPayable(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(JobAdminService.NotifyPayable, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.JobAdminServiceClient = JobAdminServiceClient;

var MerchantAdminService = (function () {
  function MerchantAdminService() {}
  MerchantAdminService.serviceName = "admin.MerchantAdminService";
  return MerchantAdminService;
}());

MerchantAdminService.UpdateMerchant = {
  methodName: "UpdateMerchant",
  service: MerchantAdminService,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_core_products_pay_v1_admin_all_pb.UpdateMerchantRequest,
  responseType: brank_as_gunk_core_products_pay_v1_admin_all_pb.UpdateMerchantResponse
};

MerchantAdminService.MerchantList = {
  methodName: "MerchantList",
  service: MerchantAdminService,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_core_products_pay_v1_admin_all_pb.MerchantListRequest,
  responseType: brank_as_gunk_core_products_pay_v1_admin_all_pb.MerchantListResponse
};

exports.MerchantAdminService = MerchantAdminService;

function MerchantAdminServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

MerchantAdminServiceClient.prototype.updateMerchant = function updateMerchant(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(MerchantAdminService.UpdateMerchant, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

MerchantAdminServiceClient.prototype.merchantList = function merchantList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(MerchantAdminService.MerchantList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.MerchantAdminServiceClient = MerchantAdminServiceClient;

